<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>{{ getCurrentCount() }}</strong> / {{ faqListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:70px">
        <col style="width:50px">
        <col style="width:120px">
        <col style="width:auto">
        <col style="width:160px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col"><span class="ui_chkbox primary nontxt"><input type="checkbox" name="" @change="toggleAllCheck($event.target.checked)"><label for=""></label></span></th>
          <th scope="col">번호</th>
          <th scope="col">FAQ 구분</th>
          <th scope="col">제목</th>
          <th scope="col">등록일</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(faq, index) in faqList"
        >
          <td>
            <span class="ui_chkbox primary nontxt">
              <input
                type="checkbox"
                :value="faq.faqSeq"
                v-model="selectedFaqs"
              >
              <label for=""></label>
            </span>
          </td>
          <td>{{ index + 1 }}</td>
          <td><span class="medium">{{ checkEmptyCategory(faq.category) }}</span></td>
          <td class="subject"><a @click="toFaq(faq.faqSeq)">{{ faq.title }}</a></td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ faq.createDate }}</span>
              <span class="time"></span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createFaq">등록</button>
      <button type="button" class="bt_base gray large_h" @click="deleteSelectedFaqs">삭제</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminFaqModule = 'adminFaqModule'
export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,
      selectedFaqs: [],

      searchOptions: [
        { name: '전체', value: 'all' },
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminFaqModule, [
      'requestFaqList',
      'requestDeleteFaqs'
    ]),

    createFaq () {
      this.$router.push({ name: "FaqManageCreatePage" })
    },

    totalPages() {
      return Math.ceil(this.faqListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestFaqList({currentPage, searchType, searchWord})
    },


    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.faqListCount)) {
        currentLastCount = this.faqListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    toggleAllCheck(isChecked) {
      if (isChecked) {
        this.selectedFaqs = []
        for (const faq of this.faqList) {
          this.selectedFaqs.push(faq.faqSeq)
        }
      } else {
        this.selectedFaqs = []
      }
    },

    async deleteSelectedFaqs() {
      if (this.selectedFaqs.length === 0) {
        alert('선택된 FAQ가 없습니다');
        return;
      }

      const { searchType, searchWord, currentPage } = this;
      const fetchFaqs = async (page = 1, type = searchType, word = searchWord, isReset = false) => {
        const params = { currentPage: page, searchType: type, searchWord: word };
        await this.requestFaqList(params);
        if (isReset) {
          this.searchType = 'all';
        }
      };

      await this.requestDeleteFaqs(this.selectedFaqs);
      this.selectedFaqs = [];

      await fetchFaqs(currentPage);

      if (this.faqList.length === 0 && this.currentPage > 1) {
        this.currentPage -= 1;
        await fetchFaqs(this.currentPage);
      }

      if (this.faqList.length === 0 || this.currentPage === 1) {
        this.currentPage = 1;
        this.searchType = '';
        this.searchWord = '';
        await fetchFaqs(1, '', '', true);
      }
    },

    checkEmptyCategory(name) {
      if (name === "") {
        return "카테고리 없음"
      } else return name
    },

    async getSearch() {
      if (this.searchWord === '') {
        alert('검색어를 입력해주세요')
        return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestFaqList({currentPage, searchType, searchWord})
    },

    toFaq (faqSeq) {
      this.$router.push({
        name: "FaqManageCreatePage",
        query: { faqSeq: faqSeq },
      });
    }
  },

  computed: {
    ...mapState(adminFaqModule, [
      'faqList',
      'faqListCount'
    ])
  },

  async mounted () {
    const {currentPage, searchType, searchWord} = this
    await this.requestFaqList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">

</style>